module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_fails.js
// module id = BI7s
// module chunks = 1